// extracted by mini-css-extract-plugin
module.exports = {"ricosDisabled":"N9s2CH","checkbox":"i_zFmo"};